export default __webpack_public_path__ + "static/media/104-social-media.7e8347e9.svg";